"use client";

import React from "react";
import AniIcon from "./AniIcon";

/**
 * Ani Combobox (Single), `Small` size.
 *
 * The trailing action is a full-height bordered cell sharing the field's right
 * radius — not a floating caret. It is `pointer-events: none` so clicks fall
 * through to the native select underneath, which keeps the real listbox and
 * its keyboard behaviour instead of reimplementing one.
 */
const AniCombobox = ({
  value,
  options,
  onChange,
  label,
  wide,
}: {
  value: string;
  options: Array<{ value: string; label: string }>;
  onChange: (next: string) => void;
  label: string;
  wide?: boolean;
}) => (
  <span
    data-token="Ani Combobox"
    className={`ani-combobox ani-tint${wide ? " ani-combobox--wide" : ""}`}
  >
    <select
      aria-label={label}
      value={value}
      onChange={(event) => onChange(event.target.value)}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
    <span className="ani-combobox-action">
      <AniIcon name="caret-down" />
    </span>
  </span>
);

export default AniCombobox;
